export enum NoteType {
    MEDICATION,
    FEEDING,
    INFO
}
